import { useMemo } from 'react'
import { Loader2, Search } from 'lucide-react'

export default function PublicCatalogFilterPanel({ products, totalCount, selectedCategories, onCategoryChange, isOpen, onToggle, searchValue, onSearchChange, onSearchSubmit, slug, isSearching = false }) {
  const categories = useMemo(() => {
    const map = new Map()
    products.forEach((product) => {
      if (product.categoryName && !map.has(product.categoryName)) {
        map.set(product.categoryName, product.categoryName)
      }
    })
    return Array.from(map, ([name]) => ({ name, slug: name }))
  }, [products])

  return (
    <div className="border border-slate-200 bg-white rounded-2xl overflow-hidden">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition"
      >
        <span>Filtros</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="px-4 pb-4 space-y-3">
          <form onSubmit={(event) => { event.preventDefault(); onSearchSubmit?.() }} className="grid gap-2">
            <input
              className="w-full min-h-[42px] rounded-xl border border-slate-200 bg-white px-4 text-sm outline-none focus:border-blue-300 focus:ring-4 focus:ring-blue-100"
              placeholder="Buscar producto..."
              value={searchValue}
              onChange={(event) => onSearchChange?.(event.target.value)}
            />
            <button
              type="submit"
              disabled={isSearching}
              className="inline-flex min-h-[42px] w-full items-center justify-center gap-2 rounded-xl bg-[var(--catalog-primary)] px-4 text-sm font-semibold text-white shadow-sm transition hover:brightness-110 disabled:cursor-wait disabled:opacity-80"
            >
              {isSearching ? (
                <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
              ) : (
                <Search className="h-4 w-4" aria-hidden="true" />
              )}
              {isSearching ? 'Buscando' : 'Buscar'}
            </button>
            <div className="flex items-center justify-between text-xs text-slate-500">
              <span>{totalCount} producto{totalCount !== 1 ? 's' : ''}</span>
              {slug && (
                <span className="text-slate-400">/catalogo/{slug}</span>
              )}
            </div>
          </form>

          {categories.length > 0 && (
            <div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-2">Categorias</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((category) => {
                  const isSelected = selectedCategories.includes(category.name)
                  return (
                    <button
                      key={category.slug}
                      type="button"
                      onClick={() => onCategoryChange(category.name)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium border transition ${
                        isSelected
                          ? 'bg-[var(--catalog-primary)] text-white border-[var(--catalog-primary)]'
                          : 'bg-white text-slate-600 border-slate-200 hover:border-slate-300'
                      }`}
                    >
                      {category.name}
                    </button>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
